import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

let cache = null;
export const useFeatures = () => {
  const [f, setF] = useState(cache);
  useEffect(() => { if (cache) return; api.get("/features").then((r) => { cache = r.data; setF(r.data); }).catch(() => setF({})); }, []);
  return f;
};

export const Flagged = ({ flag, children }) => {
  const f = useFeatures();
  if (!f) return null;
  if (f[flag]) return children;
  return (
    <div className="landing" data-testid="feature-unavailable"><section className="landing-right" style={{ margin: "0 auto" }}><div style={{ maxWidth: 460 }}>
      <h2>Not available</h2>
      <p style={{ color: "var(--ink-2)" }}>This part of ExperTraQ is not available at the moment.</p>
      <Link to="/" className="btn mt-4" data-testid="feature-unavailable-home">Back to home</Link>
    </div></section></div>
  );
};
